import css from './UserTicket.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import classNames from 'classnames'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

import Img from 'components/Media/Img'
import { useUrlCloudfront } from 'hooks/useEnv'

interface Props {
  hideCount?: boolean
  hideCorner?: boolean
}

export const UserTicketSkeleton: React.FC<Props> = (props) => {
  const { hideCount, hideCorner } = props

  const urlCloudfront = useUrlCloudfront()
  return (
    <div className={css.userTicket}>
      <div
        className={classNames(css.userTicket__oneRow, css.userTicket__count)}
        style={{ backgroundImage: hideCount ? 'none' : `url(${urlCloudfront}/images/wallet/ticket_red_h.svg)` }}
      >
        <Skeleton
          baseColor={TICKETSMS_COLORS_LIGHTGREY}
          borderRadius={16}
          height={'100%'}
          highlightColor={TICKETSMS_COLORS_WHITE}
        />
      </div>
      <div>
        <div className={css.userTicket__infoTitle__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            width={'50%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div className={css.userTicket__name__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
      </div>
      <div>
        <div className={css.userTicket__infoTitle__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div className={css.userTicket__name__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
      </div>

      <div className={classNames(css.userTicket__oneRow, css.userTicket__btnPrint, css.userTicket__btnPrint__skeleton)}>
        <Skeleton
          baseColor={TICKETSMS_COLORS_LIGHTGREY}
          borderRadius={16}
          height={'100%'}
          highlightColor={TICKETSMS_COLORS_WHITE}
        />
      </div>

      <div>
        <div className={css.userTicket__infoTitle__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div className={css.userTicket__name__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
      </div>
      <div>
        <div className={css.userTicket__infoTitle__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
        <div className={css.userTicket__name__skeleton}>
          <Skeleton
            baseColor={TICKETSMS_COLORS_LIGHTGREY}
            borderRadius={16}
            height={'100%'}
            highlightColor={TICKETSMS_COLORS_WHITE}
          />
        </div>
      </div>
      {!hideCorner && <Img className={css.userTicket__imgCorner} src="/wallet/ticket_corner_grey.svg" />}
    </div>
  )
}
